import React from 'react';
import RelatedStoriesBasic from '@/components/Pages/ArticleParts/RelatedStoriesBasic';
import { useI18n } from 'next-localization';
import { ComponentProps } from 'lib/component-props';
import { usePageData } from 'lib/page-data/PageDataContext';

type RelatedStoriesProps = ComponentProps & { className?: string };

const RelatedStories: React.FC<RelatedStoriesProps> = ({ rendering, className }) => {
  const { t } = useI18n();
  const { relatedArticles } = usePageData('article') ?? {};

  return (
    <RelatedStoriesBasic
      title={t('relatedStoriesTitle')}
      articles={relatedArticles}
      rendering={rendering}
      className={className}
    />
  );
};

export default RelatedStories;
